import utagLinkGeneric from './utagLinkGeneric';

function utagLinkSearch (eventCategory = 'Nav-Search-EA') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkSearch;
